import { useTranslation } from 'react-i18next';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link } from '@mui/material';

import { getIconByType } from '~/components/organisms/previewBar/components/vcard-plus/utils';
import { LOCATION_TYPE } from '~/constants/vCard';
import { COLORS } from '~/styles/colors';
import { formatAddress } from '~/utils/common';
import { getIconPhoneByType } from '~/utils/getIconPhone';

import {
  StyledContainer,
  StyledContentContainer,
  StyledListItem,
  StyledListItemText,
  StyledUserNameContainer,
} from './styled';

export function VCardMockup({ values }) {
  const { t } = useTranslation();

  const { location = {}, firstName, lastName, email, website, companyName, companyPosition, phones } = values || {};

  const addressString = formatAddress(location);

  const isLocationShowed =
    location.type === LOCATION_TYPE.FULL
      ? !!addressString.length
      : location.type === LOCATION_TYPE.URL
        ? location.url
        : !!(location.latitude && location.longitude);

  const getLocationLink = (type) => {
    switch (type) {
      case LOCATION_TYPE.FULL:
        return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressString)}`;
      case LOCATION_TYPE.URL:
        return location.url;
      case LOCATION_TYPE.COORDINATES:
        return `https://www.google.com/maps?q=${location.latitude},${location.longitude}&z=15&hl=en`;
      default:
        return '#';
    }
  };

  return (
    <StyledContainer>
      <StyledUserNameContainer>
        {firstName} {lastName}
      </StyledUserNameContainer>
      {!!phones?.length && (
        <StyledContentContainer>
          {phones.map((phone, index) => (
            <StyledListItem key={index}>
              {getIconPhoneByType(phone.type)}
              <StyledListItemText href={`tel:${phone.phone}`}>{phone.phone}</StyledListItemText>
            </StyledListItem>
          ))}
        </StyledContentContainer>
      )}
      {!!email && (
        <StyledContentContainer>
          <StyledListItem>
            {getIconByType('email', COLORS.black06)}
            <StyledListItemText href={`mailto:${email}`}>{email}</StyledListItemText>
          </StyledListItem>
        </StyledContentContainer>
      )}
      {!!website && (
        <StyledContentContainer>
          <StyledListItem>
            {getIconByType('website', COLORS.black06)}
            <StyledListItemText href={website} target="_blank" rel="noopener noreferrer">
              {website}
            </StyledListItemText>
          </StyledListItem>
        </StyledContentContainer>
      )}
      {isLocationShowed && (
        <StyledContentContainer>
          <StyledListItem>
            <LocationOnIcon sx={{ color: COLORS.black06, width: '16px', height: '16px' }} />
            <div>
              <StyledListItemText>{location.type === 'FULL' ? addressString : null}</StyledListItemText>
              <div>
                <Link
                  href={getLocationLink(location.type)}
                  sx={{ fontSize: 12 }}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="primary"
                  underline="none"
                >
                  {t('template5:showMap')}
                </Link>
              </div>
            </div>
          </StyledListItem>
        </StyledContentContainer>
      )}
      {!!(companyName || companyPosition) && (
        <StyledContentContainer>
          <StyledListItem>
            {getIconByType('work', COLORS.black06)}
            <StyledListItemText>
              {companyName} {companyPosition}
            </StyledListItemText>
          </StyledListItem>
        </StyledContentContainer>
      )}
    </StyledContainer>
  );
}
